import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgInfoFilled = (props) => (
  <SvgIcon {...props} title="InfoFilled">
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1Zm1-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        fill={props?.filledColor ? props.filledColor : '#fff000'}
      />
    </svg>
  </SvgIcon>
);

export default SvgInfoFilled;
